import { useEffect } from 'react';

// setActiveCards({currentTarget: !DOMRef, activeTabName: !String, menuType: oneOf['dropdown', 'tabs']])}) => void
const setActiveCards = ({ currentTarget, activeTabName, menuType }) => {
  const activeItem = currentTarget.closest('.cards').querySelector('.cards-menu__item_active');

  const contentItems = currentTarget.closest('.cards').querySelectorAll('.cards__item');

  if (currentTarget !== activeItem || menuType === 'dropdown') {
    activeItem.classList.remove('cards-menu__item_active');
    currentTarget.classList.add('cards-menu__item_active');

    contentItems.forEach((item) => {
      if (activeTabName === item.getAttribute('data-tab-name')) {
        item.classList.add('cards__item_active');
      } else {
        item.classList.remove('cards__item_active');
      }
    });
  }
};

const handleTabCardsItemClick = ({ currentTarget }) =>
  setActiveCards({
    currentTarget,
    activeTabName: currentTarget.getAttribute('data-tab-name'),
    menuType: 'tabs',
  });

const handleTabDropdownClick = ({ currentTarget }) =>
  setActiveCards({ currentTarget, activeTabName: currentTarget.value, menuType: 'dropdown' });

const setInitialActiveCards = () => {
  const sections = document.querySelectorAll('.cards');

  sections.forEach((section) => {
    const sectionMenu = section.querySelector('.cards-menu-wrapper');
    const sectionItems = section.querySelectorAll('.cards__item');

    if (sectionMenu) {
      const tabNameActive = section
        .querySelector('.cards-menu__item_active')
        .getAttribute('data-tab-name');

      sectionItems.forEach((item) => {
        if (item.getAttribute('data-tab-name') === tabNameActive) {
          item.classList.add('cards__item_active');
        } else {
          item.classList.remove('cards__item_active');
        }
      });
    } else {
      sectionItems.forEach((item) => {
        item.classList.add('cards__item_active');
      });
    }
  });
};

export default function useTabCards() {
  useEffect(() => {
    const tabCardsItems = document.querySelectorAll('.cards-menu__item');
    const dropdownMenu = document.querySelectorAll('.cards-menu-dropdown select');

    tabCardsItems.forEach((item) => item.addEventListener('click', handleTabCardsItemClick));
    dropdownMenu.forEach((item) => item.addEventListener('change', handleTabDropdownClick));

    setInitialActiveCards();

    return () => {
      tabCardsItems.forEach((item) => item.removeEventListener('click', handleTabCardsItemClick));
      dropdownMenu.forEach((item) => item.removeEventListener('change', handleTabDropdownClick));
    };
  }, []);
}
